import React from 'react';
import Page from "../components/Page/Page";

const Dashboard = () => (
    <Page title={"Tableau de bord"} className={"dashboard"}/>
)


export default Dashboard
